import MaterialTable, {Localization, MaterialTableProps} from "material-table";
import React, {useMemo} from "react";
import MTableActionIcon from "./MTableActionIcon";
import {TFunction, useTranslation} from "react-i18next";
import {cloneDeep} from "lodash";


const localization: Localization = {
    toolbar: {
        addRemoveColumns: "Add or remove columns",
        nRowsSelected: "{0} row(s) selected",
        showColumnsTitle: "Show Columns",
        showColumnsAriaLabel: "Show Columns",
        exportTitle: "Export",
        exportAriaLabel: "Export",
        exportCSVName: "Export as CSV",
        exportPDFName: "Export as PDF",
        searchTooltip: "Search",
        searchPlaceholder: "Search",
        searchAriaLabel: "Search",
        clearSearchAriaLabel: "Clear Search",
    },
    pagination: {
        firstTooltip: "First Page",
        previousTooltip: "Previous Page",
        nextTooltip: "Next Page",
        lastTooltip: "Last Page",
        labelDisplayedRows: "{from}-{to} of {count}",
        labelRowsPerPage: "Rows per page",
        labelRowsSelect: "rows"
    },
    body: {
        emptyDataSourceMessage: "No records to display",
        filterRow: {
            filterTooltip: "Filter",
        },
        editRow: {
            saveTooltip: "Save",
            cancelTooltip: "Cancel",
            deleteText: "Are you sure you want to delete this row?",
        }
    },
    header: {
        actions: "Actions"
    }
};

const translateRecursive = (obj: any, t: TFunction) => {
    if (typeof obj === 'object') {
        for (const keys in obj) {
            if (typeof obj[keys] === 'object') {
                translateRecursive(obj[keys], t)
            } else {
                const keyValue = obj[keys];
                obj[keys] = t(`m_table.${keyValue}`, keyValue);
            }
        }
    }
    return obj;
}

export default function MyMaterialTable<RowData extends object>(props: MaterialTableProps<RowData>) {
    const {t} = useTranslation();
    const translatedLocalization = useMemo(() => {
        const translatedLocalization = cloneDeep(localization);
        translateRecursive(translatedLocalization, t)
        return translatedLocalization;
    }, [t])

    return <MaterialTable<RowData>
            components={{
                Action: (props) => <MTableActionIcon {...props}/>,
            }}
            style={{width: "100%"}}
            localization={translatedLocalization}
            {...props}
    />;
}